<template>
	<a class="icon-wrapper " :href="icon.action" target="_blank">
		<div class="icon" :style="{ backgroundImage: `url(${icon.src})` }"></div>
	</a>
</template>

<script>
export default {
	props: {
		icon: {
			type: Object,
			default: () => ({}),
		},
	},
}
</script>
<style lang="scss">
.icon {
	&-wrapper {
		position: relative;
		width: 65px;
		height: 55px;
	}

	position: absolute;
	top: 0;
	left: 0;
	height: inherit;
	width: inherit;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: right;
}
</style>
